import {DoNotSellListModule} from "@/api/modules/doNotSellList/DoNotSellListModule";
import {StoreProxy} from "@/api/common/StoreProxy";
import {DoNotSellItem} from "@/api/modules/doNotSellList/DoNotSellItem";

export default {
    name: "DoNotSellList",
    data() {
        return {
            list: [],
            newPartNumber: '',
            isListLoading: false
        }
    },
    created(){

        this._module = new DoNotSellListModule(StoreProxy.getAuth(this.$store));

        let vm = this;

        this.isListLoading = true;

        this._module.getList().then(data => {
            vm.list = data;
            this.isListLoading = false;
        }).catch(e => {

            this.isListLoading = false;
            this.$notify.error({
                title: 'Retrieval Error!',
                message: 'Error retrieving the Do-Not-Sell List'
            });

        });



    },
    methods: {
        deleteItem(index, item) {

            if (item != null) {
                this.$confirm(`This will permanently delete part number ${item.partNumber} from the Do Not Sell List. Continue?`, 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this._internalDeleteItem(index, item);
                }).catch(() => {
                    window.tracer.debug("[d489166] user cancelled part deletion.");
                });
            }
            else{
                window.tracer.warn('[w450156] (Defect) Item passed from the UI is null. Unexpected situation.');
            }
        },
        _internalDeleteItem(index, item){

            try {
                if (item != null) {

                    window.tracer.debug(`[d589272] item ${index} asked to be deleted for ${item.partNumber}`);
                    let vm = this;


                    this.isListLoading = true;
                    item.deleteItem().then(() => {

                        try{
                            delete vm.list[index];

                            let tmpList = [];

                            vm.list.forEach(function (obj) {

                                if (obj != null) {
                                    tmpList.push(obj);
                                }
                            });

                            vm.list = tmpList;

                            this.isListLoading = false;
                            this.$notify.success({
                                title: `Part Number ${item.partNumber} removed from Do-Not-Sell list`
                            });
                        }
                        catch(err){
                            window.tracer.error("[e435662] General Error.");
                            window.tracer.error(err);

                            this.$notify.error({
                                title: 'General Error!',
                                message: `Error deleting part number ${item.partNumber} from Do-Not-Sell list`
                            });
                        }


                    }).catch((err) => {

                        if (err != null){
                            window.tracer.error(err);
                        }

                        this.isListLoading = false;

                        this.$notify.error({
                            title: 'Delete Error!',
                            message: `Error deleting part number ${item.partNumber} from Do-Not-Sell list`
                        });


                    });
                } else {
                    window.tracer.debug(`[d476760] item ${index} has a null element.`);
                }
            }
            catch(err) {
                window.tracer.error("[e240172] General Error.");
                window.tracer.error(err);

                this.$notify.error({
                    title: 'General Error!',
                    message: `Error deleting part number ${item.partNumber} from Do-Not-Sell list`
                });
            }
        },
        saveItem(){

            if (this.newPartNumber.length == 0){
                return;
            }

            let vm = this;

            this._module.saveItem(this.newPartNumber).then(() => {

                let item = new DoNotSellItem(this.newPartNumber);
                vm.list.push(item);

                vm.newPartNumber = '';
                this.$notify.success({
                    title: `Part Number ${item.partNumber} saved to Do-Not-Sell list`,
                });

            }).catch(() => {
                this.$notify.error({
                    title: 'Save Error!',
                    message: `Error saving part number ${vm.newPartNumber } to Do-Not-Sell list`
                });
            });
        }
    }
}